import React from "react";

export const LikeHeartIcon = () => (
  <svg
    className="like-icon"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
  >
    <path
      className="like-glow"
      d="M12 20.4 C 7 16, 3 13, 3 8.5 C 3 5.8, 5 4, 7.5 4 C 9.3 4, 10.8 4.8, 12 6 C 13.2 4.8, 14.7 4, 16.5 4 C 19 4, 21 5.8, 21 8.5 C 21 13, 17 16, 12 20.4 Z"
    />
  </svg>
);

export const CommentBubbleIcon = () => (
  <svg className="ic-comment" viewBox="0 0 16 16" aria-hidden="true">
    <path d="M2.5 5 a2 2 0 0 1 2 -2 h7 a2 2 0 0 1 2 2 v4 a2 2 0 0 1 -2 2 h-3.5 l-2.5 2.2 v-2.2 h-1 a2 2 0 0 1 -2 -2 z" />
  </svg>
);

export const ChevronDownIcon = () => (
  <svg className="ic-inline" viewBox="0 0 12 12" aria-hidden="true">
    <path d="M3 4.5 L6 7.5 L9 4.5" />
  </svg>
);

export const ChevronUpIcon = () => (
  <svg className="ic-inline" viewBox="0 0 12 12" aria-hidden="true">
    <path d="M3 7.5 L6 4.5 L9 7.5" />
  </svg>
);
